<template>
  <div class="footer">
    <b-container>
      <b-row class="">
        <b-col md="3" class="center">
          <div>
            <div class="btn btn-danger" show @click="click" v-if="maintenance && maintenance.maintenanceEnabled == true">
              <div class="icon"><font-awesome-icon icon="wrench" /></div>
              <div class="">
                Maintenance: {{ startDate }}-{{ endDate }} <br />
                Click for more info
              </div>
            </div>
          </div>
        </b-col>
        <b-col md="6" class="copyright">
          Copyright © {{ year }} K3 Capital Group Limited
        </b-col>
        <b-col md="3"> </b-col>
      </b-row>
    </b-container>
    <MaintenanceModel :maintenance="maintenance" ref="maintenanceModal"/>
  </div>
</template>

<script>
import MaintenanceModel from "@/components/shared/MaintenanceModel.vue";
import SystemService from "@/services/System.service";
import { format, addMinutes, parseISO } from "date-fns";

export default {
  name: "Footer",
  props: {
    user: String,
  },
  components: {
    MaintenanceModel
  },
  mounted() {
    SystemService.getMaintenance().then((x) => {
      this.maintenance = x.data;
    });
  },
  computed: {
    year() {
      var date = new Date();
      return date.getFullYear();
    },
    startDate() {
      if (!this.maintenance || !this.maintenance.maintenanceDueDateTime) {
        return "";
      } else {
        return format(
          parseISO(this.maintenance.maintenanceDueDateTime),
          "dd/MM/yy h:mma"
        );
      }
    },
    endDate() {
      if (!this.maintenance || !this.maintenance.maintenanceDueDateTime) {
        return "";
      } else {
        return format(
          addMinutes(
            parseISO(this.maintenance.maintenanceDueDateTime),
            this.maintenance.maintenanceLength
          ),
          "h:mma"
        );
      }
    }
  },
  methods: {
    click() {
      this.$refs.maintenanceModal.showModal();
    }
  },
  data() {
    return {
      maintenance: null,
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.footer {
  width: 100%;
  background-color: #252658;
  height: 62px;
}

.copyright {
  font-size: 16px;
  text-align: center;
  color: rgba(255, 255, 255, 0.5);
  padding-top: 5px;
}

.container {
  max-width: 100%;
}

.center {
  text-align: center;
  width: 410px;
}

/*.btn-danger.center > div {
  padding-left: 70px;
}*/

.btn-danger {
  display: flex;
  overflow: hidden;
  height: 60px;
  max-width:370px;
}

.icon {
  font-size: 1.5em;
  padding: 4px;
  padding-right: 10px;
}
</style>
